import { calculateOrderPrice } from "./deliveryOrder.js";

export async function addAddressCard(info) {
    const card = document.createElement('label');
    const id = `address-select-${info.id}`;
    card.classList.add('address-item');
    card.for = id;
    card.innerHTML = `
        <div class="custom-radio-label">
            <input type="radio"
                name="delivery_address__selector"
                id="${id}"
            >${info.address}
        </div>
    `;
    const input = card.querySelector('input');
    input.addEventListener('click',()=>{
        calculateOrderPrice(info.address, '136')
    });
    return card;
}